import { Group, Text, ThemeIcon, Tooltip } from "@mantine/core";
import { IconShieldLock } from "@tabler/icons-react";

const SECURITY_EMAIL_EXPLANATION =
  "This security email always sends. Review and Off are unavailable because " +
  "delaying this email could prevent someone from accessing their account " +
  "before its link expires.";

export function NonHoldableEmailInfo() {
  return (
    <Tooltip
      label={SECURITY_EMAIL_EXPLANATION}
      maw={340}
      multiline
      offset={8}
      position="top"
      withArrow
      withinPortal
    >
      <Group
        aria-label="Why this security email always sends"
        component="span"
        gap={6}
        role="status"
        tabIndex={0}
        wrap="nowrap"
      >
        <ThemeIcon color="blue" size="sm" variant="light">
          <IconShieldLock aria-hidden="true" size={14} />
        </ThemeIcon>
        <Text c="blue.7" fw={600} size="sm">
          Always sends
        </Text>
      </Group>
    </Tooltip>
  );
}
